/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="../controllers/app.common.controllers.module.ts" />
/// <reference path="../iapirequestconfig.ts" />
/// <reference path="../services/apiservice.ts" />
/// <reference path="../controllers/screencontrollerbase.ts" />
/// <reference path="../services/usermessagesservice.ts" />

module App.Common.Controllers {
	'use strict';

	/**
	 * The click callback function interface. 
	 * This callback function should be defined on the parent
	 * with this signature so that OrsumTable can call it.
	 * If click events are to be handled then this value mnust be defined.
	 */
	export interface IOrsumTableClickCallback {
		(row: any, actionName?: string, ngClickEvent?: angular.IAngularEvent): void
	}

	/**
	 * The filter callback function interface.
	 * This callback function should be defined on the parent
	 * with this signature so that OrsumTable can call it.
	 * If filter events are to be handled within the parent then this value must be defined
	 * otherwise OrsumTable will filter the table using it's inbuilt filtrering mechanism.
	 */
	export interface IOrsumTableFilterCallBack {
		(filter: string, filterColumn: string): any[]
	}

	/**
	 * The OrsumTable configuratrion
	 */
	export class OrsumTableConfig {
		/**
		 * The unique name assigned to this OrsumTable.
		 * Each OrsumTable in a view should have a unique name.
		 */
		public uniqueName: string;
		/**
		 * The configuration of each column in the table
		 */
		public columns: IOrsumTableColumnConfig[];
		/**
		 * The rows of data.
		 * PLEASE NOTE: If this is null then webApiConfig must be provided.
		 */
		public rows: any[];
		/**
		 * An expression to be added to the ng-click attribute on each table row
		 */
		public rowClick: string = null;
		/**
		* The initialize  
		*/
		public orsumTableController: OrsumTableController;
		/**
		* The callback function that will be called on the
		* parent when a clickable object is activated.
		*/
		public clickCallBack: string; //IOrsumTableClickCallback;
		/**
		* The callback function that will be called on the
		* parent when the user is filtering the data.
		* If this value is null then OrsumTable will perform it's own filtering.
		*/
		public filterCallBack: string; //IOrsumTableFilterCallBack;
		/**
		 * The host controller which is hosting the OrsumTable configuration
		 */
		public hostController: any;
		/**
		 * Add a specific class to table when Orsum table is shown on modal pop-up only
		 */
		public tableClass: string;
	}

	/**
	 * The OrsumTable column configuration
	 */
	export interface IOrsumTableColumnConfig {
		/**
		 * The original column id as it appears in the view model
		 */
		columnId: string;
		/**
		 * The column display as it should appear in the column header
		 */
		columnDisplayName: string;
		/**
		 * The column display template. This can be a combinition of html and angular.
		 * The basic format to display the view model id column would be {{row["id"]}}.
		 * The term row must be used as the "row" is used in the parent ng-repeat="row in tableData"
		 */
		columnDisplayTemplate?: string;

		columnDisplayTemplateHtml?: string;

		notSortable?: boolean;

		notClickable?: boolean;

		notGroupable?: boolean;
}

	/**
	 * A single group of related rows
	 */
	export class OrsumTableGroup<T> {
		public groupData: T[];
		public groupKey: string;
		constructor() {
			this.groupData = [];
			this.groupKey = '';
		}
	}

	/**
	 * A number of groups of grouped rows
	 */
	export class OrsumTableGroupedData<T> {
		public numberOfGroups: number;
		public groups: OrsumTableGroup<T>[];

		constructor() {
			this.numberOfGroups = 0;
			this.groups = [];
		}

		public reset(): void {
			this.numberOfGroups = 0;
			this.groups = [];
		}
	}

	/**
	 * The main controller for OrsumTable
	 */
	export class OrsumTableController {
		//required dependencies
		public static $inject = ['$rootScope', '$scope', '$injector'];
		//required web api service
		public api: Common.Services.ApiService;
		//the configuration for the table and source of table data
		private configuration: OrsumTableConfig;
		//the grouped, sorted and filtered data 
		private groupedTableData = new OrsumTableGroupedData<any>();
		//the id of this instance of OrsumTable
		private thisOrsumTableId: number;

		//the column by which to sort the data and the direction
		public sortByColumnId: string;
		public sortByColumnReverse = false;
		//the column by which to group the data and indication if grouping has been selected
		public groupByColumnId: string;
		public groupByColumnSelected = false;
		//the filter string, the column by which to filter the data and indication if filter has been selected
		public filterBy: string;
		public filterByColumnId: string;
		public filterByColumnSelected = false;
		//the column header names found from the first row of the data
		public rowColumns: string[];
		//flag to indicate that the data has been provided
		public hasInitialised = false;
		/**
		 * Create instance of this controller
		 * @param $rootScope
		 * @param $scope
		 * @param $injector
		 */
		constructor(private $rootScope: any, private $scope: any, $injector: angular.auto.IInjectorService) {
			this.api = $injector.get<Common.Services.ApiService>('app.common.services.apiService');
			this.configuration = $scope.ostConfig;
			//assign the initialize method so it can be called by the parent controller
			this.configuration.orsumTableController = this;
			//call the initialise
			this.initialize();
		}

		/**
		 * Initialize the controller with the data that must be displayed in the table
		 * @param data
		 */
		public initialize(data?: any[]): void {
			if (!!data) {
				this.configuration.rows = data;
				this.groupedTableData = this.groupSortFilterRawData(this.configuration.rows, this.groupByColumnId, this.sortByColumnId);
				this.rowColumns = this.getColumnHeaders();
				this.hasInitialised = true;
			}
		}

		/**
		 * Gets the field names from the first row of the data
		 * and returns them as column headers
		 */
		public getColumnHeaders(exclude?: string): string[] {
			let result: string[] = [];
			if (this.configuration.rows && this.configuration.rows[0]) {
				let keys = Object.keys(this.configuration.rows[0]);
				for (var i = 0; i < keys.length; i++) {
					if (keys[i].substr(0, 1) !== '$' && keys[i] !== exclude) {
						result.push(keys[i]);
					}
				}
			}
			return result;
		}

		/**
		 * Sets the grouping criteria for the table data 
		 * @param groupBy
		 */
		public setGroupBy(groupBy: string): void {
			this.groupByColumnSelected = false;
			this.groupByColumnId = null;
			if (!!(groupBy) && groupBy !== 'None') {
				this.groupByColumnSelected = true;
				this.groupByColumnId = groupBy;
			}
			this.getRows(this.groupByColumnId, this.sortByColumnId, this.filterBy);
			this.reset();
		}

		/**
		 * Sets the sort order of data within a group
		 * @param sortBy
		 */
		public setSortBy(sortBy: string): void {
			if (sortBy === this.sortByColumnId && this.sortByColumnReverse) {
				this.sortByColumnReverse = false;
				this.sortByColumnId = null;
			} 
			else if (sortBy === this.sortByColumnId) {
				this.sortByColumnReverse = !this.sortByColumnReverse;
			} else {
				this.sortByColumnId = sortBy;
				this.sortByColumnReverse = false;
			}
			this.recalcTableData();
		}

		/**
		 * Set the filter field
		 * @param filterBy
		 */
		public setFilterBy(filterByColumnId: string): void {
			this.filterByColumnSelected = false;
			this.filterByColumnId = null;
			if (!!(filterByColumnId) && filterByColumnId !== 'All Columns') {
				this.filterByColumnSelected = true;
				this.filterByColumnId = filterByColumnId;
			}
			this.recalcTableData();
		}

		/**
		 * Perform the filter search
		 */
		public recalcTableData(): void {
			this.getRows(this.groupByColumnId, this.sortByColumnId, this.filterBy);
			this.reset();
		}

		/**
		 * Gets the number of groups found with the current groupBy clause
		 */
		public getNumberOfGroups(): number {
			return this.groupedTableData.numberOfGroups;
		}

		/**
		 * Get an zero based array of integers representing the group indexes.
		 * This is used to iterate through all available groups
		 * @param numberOfGroups
		 */
		public getGroupIndex(numberOfGroups: number): number[] {
			let result: number[] = [];
			for (var i = 0; i < numberOfGroups; i++) {
				result.push(i);
			}
			return result;
		}

		/**
		 * Get the group of rows contained within the indexed group
		 * @param index
		 */
		public getGroup(index: number): any[] {
			if (this.groupedTableData.numberOfGroups >= 1) {
				return this.groupedTableData.groups[index].groupData;
			} else {
				return null;
			}
		}

		/**
		 * Get the value by which the indexed group of rows is grouped
		 * @param index
		 */
		public getGroupKey(index: number): string {
			if (this.groupedTableData.numberOfGroups >= 1) {
				return this.groupedTableData.groups[index].groupKey;
			} else {
				return null;
			}
		}

		/**
		 * Get the total number of rows in the data
		 */
		public getTotalRows(): number {
			let rows = 0;
			if (!!this.configuration && !!this.configuration.rows) {
				rows = this.configuration.rows.length;
			}
			return rows;
		}

		/**
		 * Toggle the state of Expand or Collapse on the grouped rows
		 * @param target
		 */
		public expandCollapseToggle(target: any): void {
			if (!!(target)) {
				let id = `#expalapse${target.$id}`;
				jQuery(id).toggleClass('expand').toggleClass('collapsed').nextUntil('tr.groupHeader').slideToggle(100);
			}
		}

		/**
		 * Setup the view
		 * @param target
		 */
		public registerTable(id: number): void {
			this.thisOrsumTableId = id;
			//for (var i = 0; i < this.configuration.columns.length; i++) {
			//	let selector = `#colHeader${this.configuration.columns[i].columnId}`;
			//}
		}

		/**
		 * Get the display name for the provided view model name
		 * @param clmnHdr
		 */
		public getColumnDisplayName(clmnHdr: string): string {
			let result = clmnHdr;
			for (var i = 0; i < this.configuration.columns.length; i++) {

				if (this.configuration.columns[i].columnId === clmnHdr) {
					result = this.configuration.columns[i].columnDisplayName;
					break;
				}
			}
			return result;
		}

		public getColumnDisplayFormat(clmnHdr: string): string {
			let result = `{{${clmnHdr}}}`;
			for (var i = 0; i < this.configuration.columns.length; i++) {
				if (this.configuration.columns[i].columnId === clmnHdr) {
					result = this.configuration.columns[i].columnDisplayTemplate;
					break;
				}
			}
			return result;
		}

		/**
		 * Invoke the viewModel.Method(params) which is expected to reside on the scope.$parent
		 * Note - if this directive is nested within another directive then it may be necessary to iterate
		 * down through the $parent until the .$scope.$parent.....$parent[viewModel] is located
		 * @param viewModelMethod
		 * @param params
		 */
		public clickCallBack(row: any, actionName: string, ngClickEvent?: angular.IAngularEvent): void {
			if (!!this.configuration.clickCallBack) {
				if (ngClickEvent !== undefined) {
					this.configuration.hostController[this.configuration.clickCallBack](row, actionName, ngClickEvent);
				}
				else {
					this.configuration.hostController[this.configuration.clickCallBack](row, actionName);
				}
			}
			this.recalcTableData();
		}

		/**
		 * Reset the collapsed groups to expanded
		 */
		private reset(): void {
			jQuery(`#orsumTable${this.thisOrsumTableId} .groupHeader.collapsed`).toggleClass('expand').nextUntil('tr.groupHeader').slideToggle(100);
			jQuery(`#orsumTable${this.thisOrsumTableId} .groupHeader.collapsed`).toggleClass('collapsed');
		}

		/**
		 * Returns the table data grouped and sorted 
		 */
		private getRows(groupBy: string, sortBy: string, filterBy: string): void {
			this.groupedTableData = this.groupSortFilterRawData(this.configuration.rows, groupBy, sortBy, filterBy);
		}

		/**
		 * Filter the rawData return rows containing the supplied filter
		 * @param rawData
		 * @param filterBy
		 */
		private filterRawData(rawData: any[], filterBy?: string): any[] {
			if (!!(filterBy) && filterBy.length > 0) {
				rawData = _.filter(rawData, (item: any) => {
					let result = false;
					let fields = this.getColumnHeaders();
					if (!!(this.filterByColumnId)) {
						//we have a filter by column - only check for matches in the specified column
						if (item[this.filterByColumnId].toString().toLowerCase().indexOf(filterBy.toLowerCase()) !== -1) {
							result = true;
						}
					} else {
						//search for matches in all columns
						for (var k = 0; k < fields.length; k++) {
							if (!!(item[fields[k]]) && item[fields[k]].toString().toLowerCase().indexOf(filterBy.toLowerCase()) !== -1) {
								result = true;
								break;
							}
						}
					}
					return result;
				});
			}
			return rawData;
		}

		/**
		 * Group the raw data, by the groupBy, into the OrsumTableGroupedData
		 * @param rawData
		 * @param groupBy
		 */
		private groupRawData(rawData: any[], groupBy?: string): OrsumTableGroupedData<any> {
			let result = new OrsumTableGroupedData<any>();
			let group = new OrsumTableGroup<any>();
			if (!!(groupBy)) {
				//sort data by the specified group
				let sortByGroupByResult = _.sortBy(rawData, groupBy);
				for (var i = 0; i < sortByGroupByResult.length; i++) {
					//look if we have detected a new group
					if ((i === 0) || (this.getKeyValue(sortByGroupByResult[i], groupBy) !== this.getKeyValue(sortByGroupByResult[i - 1], groupBy))) {
						//save the last group
						result.groups.push(group);
						//create a new group
						group = new OrsumTableGroup<any>();
						result.numberOfGroups += 1;
						group.groupKey = this.getKeyValue(sortByGroupByResult[i], groupBy);
					}
					//push the data into the current group
					group.groupData.push(sortByGroupByResult[i]);
				}
				//save the last group
				result.groups.push(group);
				//drop the first, empty group
				result.groups.shift();
			} else {
				//no grouping - all in 1 group
				result.numberOfGroups = 1;
				group.groupData = rawData;
				result.groups.push(group);
			}
			return result;
		}

		/**
		 * Sort the rows by the sortBy within each of the groups
		 * @param groupedTableData
		 * @param sortBy
		 */
		private sortGroupedTableData(groupedTableData: OrsumTableGroupedData<any>, sortBy?: string): OrsumTableGroupedData<any> {
			if (!!(sortBy)) {
				//sort each group
				for (var j = 0; j < groupedTableData.groups.length; j++) {
					groupedTableData.groups[j].groupData = _.sortBy(groupedTableData.groups[j].groupData, sortBy);
					//reverse the order if required
					if (this.sortByColumnReverse) {
						groupedTableData.groups[j].groupData.reverse();
					}
				}
			}
			return groupedTableData;
		}

		/**
		 * Return the rawData after it has been grouped and sorted
		 * @param rawData
		 * @param groupBy
		 * @param sortBy
		 * @param filterBy
		 */
		private groupSortFilterRawData(rawData: any[], groupBy?: string, sortBy?: string, filterBy?: string): OrsumTableGroupedData<any> {
			let result: OrsumTableGroupedData<any>;
			//Step 1 - filter the data
			if (!!this.configuration.filterCallBack) {
				//call the parent filterby function
				//the parent will filter and set the data into the rows
				rawData = this.configuration.hostController[this.configuration.filterCallBack](filterBy, this.filterByColumnId);
			} else {
				rawData = this.filterRawData(rawData, filterBy);
			}
			//Step 2 - Perform the groupBy
			result = this.groupRawData(rawData, groupBy);
			//Step 3 - perform the sort by
			result = this.sortGroupedTableData(result, sortBy);
			//return the results
			return result;
		}

		/**
		 * Get the value of the key from object
		 * @param object
		 * @param key
		 */
		private getKeyValue(object: Object, key: string): any {
			let result: any = null;
			if (!!(object)) {
				result = object[key];
			}
			return result;
		}

	}

	angular
		.module('app.common.controllers')
		.controller('app.common.controllers.orsumTableController', OrsumTableController);

}
